import {AfterViewInit, Directive, ElementRef, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Directive({
  selector: '[appSubsectionScroll]',
  standalone: true,
})
export class SubsectionScrollDirective implements AfterViewInit {
  private readonly route = inject(ActivatedRoute);
  private readonly el = inject(ElementRef);

  ngAfterViewInit(): void {
    const subsection = this.route.snapshot.paramMap.get('subsection');
    if (!subsection) return;

    const elem: HTMLElement = this.el.nativeElement;
    const elemSubsection = elem.dataset['subsection'];
    if (elemSubsection && elemSubsection !== subsection) return;

    globalThis.setTimeout(elem.scrollIntoView.bind(elem), 500);
    globalThis.setTimeout(() => {
      const actionBtn = elem.querySelector<HTMLElement>('button.subsection-action');
      // Simulate click for a smooth user workflow
      if (actionBtn) actionBtn.click();
    }, 750);
  }
}
